<template>
    <div class="mt-5 mb-5">
      <!-- Card for Colectivos -->
      <div class="mt-12 card hover-scale-card shadow-sm">
        <div class="card-header bg-dark text-white text-center">
          <h1 class="page-title">Acerca de Agilesinfiltros</h1>
        </div>

        <div class="card-body">
          <div class="entry-content" itemprop="text">
            <p class="texto_des" style="color:#6a2481">
              No eres el único que, aunque cree en lo importante que son las guías, los libros y las certificaciones para la mejora continua 
              personal, cuando te encuentras con la vida real, te das cuenta que sobre el papel todo es posible pero que en tu proyecto la vida 
              no es color de rosa, por el contrario todo es muy complicado.
            </p>
            <p class="texto_des" style="color:#6a2481">
              Nos cansamos de oír de la «resistencia al cambio» pero pocos te dicen como abordarla, aquí tampoco hay receta mágica, pero vamos a 
              escuchar la experiencias de muchos y seguro te darán ideas para probar dentro de la realidad que tenemos… esto es Agile sin filtros
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    // No script needed for this static component
    export default {};
  </script>
  
  <style scoped>
  /* No specific styles needed for this component */
  </style>